module.exports = __webpack_public_path__ + "static/offer-d-1-new-8405da0f5fe2ef39308c728f79c3f73e.jpg";